<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="items"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    :height="tableHeight"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Lead Amortization</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @input="searchTable()"
          />

          <LeadAmortizationExtendedSummaryModal
            v-model="summaryModal"
            :item="summaryItem"
            @close-modal="closeSummary()"
            @click:outside="closeSummary()"
          />
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.schedule_match="{ item }">
      {{ item.schedule_match == 1 ? 'Yes' : 'No' }}
    </template>

    <template #item.setup_match="{ item }">
      {{ item.setup_match == 1 ? 'Yes' : 'No' }}
    </template>

    <template #item.created="{ item }">
      {{ formatDateTime(item.created) }}
    </template>

    <template #item.last_updated="{ item }">
      {{ formatDateTime(item.last_updated) }}
    </template>

    <template #item.actions="{ item }">
      <v-btn
        color="primary"
        size="small"
        variant="text"
        @click="showSummary(item)"
      >
        Extended Summary
      </v-btn>
    </template>
  </v-data-table-server>
</template>

<script>
import { DateTime } from 'luxon';
import dataTableMixin from '@/mixins/dataTableMixin.js';

import LeadAmortizationExtendedSummaryModal from '@/views/Leads/Amortization/LeadAmortizationExtendedSummaryModal.vue';

export default {
  name: 'LeadAmortizationIndex',
  components: {
    LeadAmortizationExtendedSummaryModal,
  },
  mixins: [
    dataTableMixin,
  ],
  props: {
    height: {
      type: Number,
      required: false,
      default: 800,
    },
  },
  data: () => ({
    headers: [
      { title: 'ID', value: 'id', sortable: false },
      { title: 'Lead ID', value: 'lead_id', sortable: false },
      { title: 'Schedule Match', value: 'schedule_match', sortable: false },
      { title: 'Setup Match', value: 'setup_match', sortable: false },
      { title: 'Created', value: 'created', sortable: false },
      { title: 'Updated', value: 'last_updated', sortable: false },
      { title: 'Actions', value: 'actions', sortable: false },
    ],
    summaryModal: false,
    summaryItem: {},
  }),
  computed: {
    tableHeight() {
      const newTableHeight = this.height - 350;
      return `${newTableHeight}px`;
    },
  },
  methods: {
    closeSummary() {
      this.summaryModal = false;
      this.$nextTick(() => {
        this.summaryItem = {};
      });
    },
    showSummary(item) {
      this.summaryItem = { ...item };
      this.summaryModal = true;
    },
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/lead/amortization', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          this.loading = false;
          console.error('Error fetching lead amortization data:', error);
        });
    },
    formatDateTime(date) {
      return DateTime.fromISO(date).toUTC().toFormat('yyyy-MM-dd HH:mm:ss');
    },
  },
};
</script>
